import { render, staticRenderFns } from "./AuroraIncomeVerification.vue?vue&type=template&id=461d33fe"
import script from "./AuroraIncomeVerification.vue?vue&type=script&lang=js"
export * from "./AuroraIncomeVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports